const t = {
  name: "Scalability",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,28v-3h2v3h3v2h-3v3h-2v-3H7v-2H10z"/>
		<path class="st0" d="M40,0H0v40h40V0z M22,38V17.9H2V2h36v36H22z M2,19.9h18v18H2V19.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Scalability
};
